import {PageFragment, PageFragmentProps, PageFragmentState} from "@/shared/PageFragment";
import {LabelerTask} from "@/fyneai-shared/types";
import React from "react";
import {Button, Card, Grid, Typography} from "@mui/material";
import {PD_LG, PD_XLG, PD_XLG2} from "../../../../shared/dimens";
import {ContentCopyOutlined} from "@mui/icons-material";
import {StyledBoxColumn} from "../../../../shared/StyledComponents";
import {BaseApp, getProvisioningId} from "@/shared/BaseApp";

export type TaskLabelsFragmentProps = PageFragmentProps & {
  task: LabelerTask,
}

type TaskLabelsFragmentState = PageFragmentState & {}

export class TaskLabelsFragment extends PageFragment<TaskLabelsFragmentProps, TaskLabelsFragmentState> {

  protected getTitle(): string | null | undefined {
    return "Labels";
  }

  renderContent(): React.ReactElement {
    return <Grid container>
      <Grid md={4}>
        <StyledBoxColumn style={{padding: PD_XLG2}}>
          <Card variant={"outlined"} style={{
            width: 280,
            aspectRatio: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: PD_XLG,
            gap: PD_LG,
            textAlign: "center",
          }}>
            <Typography variant={"h6"}>Web Label</Typography>
            <Typography variant={"body2"} color={"textSecondary"}>
              Label cases on the web with your internal labelers team.
            </Typography>
            <Button
              variant={"outlined"}
              startIcon={<ContentCopyOutlined/>}
              onClick={() => {
                const url = `${window.location.hostname === "localhost" ? "http://localhost:3001" : "https://labeler.fyne.ai"}/?_pgid=${getProvisioningId()}`;
                navigator.clipboard.writeText(url)
                  .then(() => BaseApp.CONTEXT.showToast("Link copied."));
              }}>
              Copy link to Share
            </Button>
          </Card>
        </StyledBoxColumn>
      </Grid>
    </Grid>
  }
}
